export const ERRORS = {
  couldNotCloseIssue: 'Could not close issue',
  couldNotReOpenIssue: 'Could not reopen issue',
  missingReopenPermission: 'You do not have permissions to reopen this issue',
  missingClosePermission: 'You do not have permissions to close this issue',
}
